import { Action, createReducer, on } from '@ngrx/store';
import { ILoanProfileOption } from '@partners/api';
import { StateBuilder } from '../../../model/state.builder';
import { SimulatorActions } from './simulator.actions';
import { ISimulatorState } from './simulator.state';

export const initialSimulatorState: ISimulatorState = {
  model: undefined,
  data: undefined,
  profileOption: undefined,
  uiState: undefined
};

const simulatorReducerFn = createReducer(
  initialSimulatorState,
  on(SimulatorActions.reset, (state: ISimulatorState, action) => {
    return new StateBuilder<ISimulatorState>(initialSimulatorState).build();
  }),
  on(SimulatorActions.unSelectProfileOption, (state: ISimulatorState, action) => {
    // const mutation = { profileOption: {} as ILoanProfileOption };
    return new StateBuilder<ISimulatorState>(state, /*mutation*/).toLoading().build();
  }),
  on(SimulatorActions.selectProfileOption, (state: ISimulatorState, action) => {
    const { profileOption } = action;
    const mutation = { profileOption: { ...profileOption } };
    return new StateBuilder<ISimulatorState>(state, mutation).toLoading().build();
  }),
  on(SimulatorActions.load, (state: ISimulatorState, action) => {
    return new StateBuilder<ISimulatorState>(state).toLoading().build();
  }),
  on(SimulatorActions.loadFailure, (state: ISimulatorState, action) => {
    return new StateBuilder<ISimulatorState>(state, action).toLoaded().build();
  }),
  on(SimulatorActions.loadSuccess, (state: ISimulatorState, action) => {
    return new StateBuilder<ISimulatorState>(state, action).toLoaded().build();
  }),
  on(SimulatorActions.submit, (state: ISimulatorState, action) => {
    return new StateBuilder<ISimulatorState>(state).toLoading().build();
  }),
  on(SimulatorActions.submitSuccess, (state: ISimulatorState, action) => {
    return new StateBuilder<ISimulatorState>(state, action).toLoaded().build();
  })
);

export function simulatorReducer(state: ISimulatorState | undefined, action: Action) {
  return simulatorReducerFn(state, action);
}
